/* Acabado premium: pinceladas de textura en gel.
   - Ajusta el precio segun el lado mayor del tamano elegido (<=100 cm / >100 cm).
   - Al anadir al carrito, mete el gel como linea aparte antes de que
     Dawn procese el producto principal. */

(function () {
  function initGallery(root) {
    var gallery = root.querySelector('[data-gel-gallery]');
    if (!gallery || gallery.dataset.ready === '1') return;
    gallery.dataset.ready = '1';

    var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-gel-slide]'));
    var dots = Array.prototype.slice.call(gallery.querySelectorAll('[data-gel-dot]'));
    var previous = gallery.querySelector('[data-gel-prev]');
    var next = gallery.querySelector('[data-gel-next]');
    var zoom = gallery.querySelector('[data-gel-zoom]');
    var lightbox = root.querySelector('[data-gel-lightbox]');
    var lightboxImage = root.querySelector('[data-gel-lightbox-image]');
    var lightboxClose = root.querySelector('[data-gel-lightbox-close]');
    var lightboxPrevious = root.querySelector('[data-gel-lightbox-prev]');
    var lightboxNext = root.querySelector('[data-gel-lightbox-next]');
    var current = 0;
    var timer = null;
    var visible = true;
    var paused = false;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (slides.length < 2) return;

    function show(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach(function (slide, slideIndex) {
        var active = slideIndex === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach(function (dot, dotIndex) {
        var active = dotIndex === current;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
      if (lightbox && lightbox.open && lightboxImage) {
        var activeImage = slides[current].querySelector('img');
        lightboxImage.src = activeImage.currentSrc || activeImage.src;
        lightboxImage.alt = activeImage.alt;
      }
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    function start() {
      stop();
      if (reduceMotion || paused || !visible || document.hidden || (lightbox && lightbox.open)) return;
      timer = window.setInterval(function () {
        show(current + 1);
      }, 4800);
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        show(parseInt(dot.dataset.gelDot, 10) || 0);
        start();
      });
    });
    if (previous) previous.addEventListener('click', function () { show(current - 1); start(); });
    if (next) next.addEventListener('click', function () { show(current + 1); start(); });

    function openLightbox() {
      if (!lightbox || !lightboxImage || typeof lightbox.showModal !== 'function') return;
      var activeImage = slides[current].querySelector('img');
      lightboxImage.src = activeImage.currentSrc || activeImage.src;
      lightboxImage.alt = activeImage.alt;
      paused = true;
      stop();
      lightbox.showModal();
    }

    function closeLightbox() {
      if (lightbox && lightbox.open) lightbox.close();
    }

    if (zoom) zoom.addEventListener('click', openLightbox);
    if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
    if (lightboxPrevious) lightboxPrevious.addEventListener('click', function () { show(current - 1); });
    if (lightboxNext) lightboxNext.addEventListener('click', function () { show(current + 1); });
    if (lightbox) {
      lightbox.addEventListener('click', function (event) {
        if (event.target === lightbox) closeLightbox();
      });
      lightbox.addEventListener('close', function () {
        paused = false;
        start();
      });
    }

    gallery.addEventListener('pointerenter', function () { paused = true; stop(); });
    gallery.addEventListener('pointerleave', function () { paused = false; start(); });
    gallery.addEventListener('focusin', function () { paused = true; stop(); });
    gallery.addEventListener('focusout', function (event) {
      if (gallery.contains(event.relatedTarget)) return;
      paused = false;
      start();
    });
    document.addEventListener('visibilitychange', start);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0] && entries[0].isIntersecting;
        start();
      }, { threshold: 0.2 }).observe(gallery);
    }

    show(0);
    start();
  }

  function init(root) {
    if (root.dataset.gelReady === '1') return;
    root.dataset.gelReady = '1';

    initGallery(root);

    var check = root.querySelector('[data-gel-check]');
    var priceEl = root.querySelector('[data-gel-price]');
    var rateEl = root.querySelector('[data-gel-rate]');

    var section = root.closest('.section') || root.closest('[id^="shopify-section"]') || document;
    var form = section.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    // En Dawn el boton de compra NO cuelga del <form>: se asocia con form="id".
    // Por eso hay que buscarlo tambien fuera, o el listener nunca se engancha.
    var submitBtn =
      form.querySelector('[type="submit"]') ||
      (form.id && section.querySelector('[type="submit"][form="' + form.id + '"]')) ||
      section.querySelector('button[name="add"]') ||
      (form.id && document.querySelector('[type="submit"][form="' + form.id + '"]'));

    // --- Lado mayor del tamano seleccionado ---------------------------------
    // Ojo: en Dawn el selector de variantes vive FUERA del <form>, asi que
    // hay que mirar toda la seccion, no solo el formulario.
    function ladoMayor() {
      var textos = [];
      var ambito = section;

      ambito.querySelectorAll('input[type="radio"]:checked').forEach(function (i) {
        textos.push(i.value || '');
        // Dawn pone el texto visible en el label asociado
        var lbl = i.labels && i.labels[0];
        if (lbl) textos.push(lbl.textContent || '');
      });
      ambito.querySelectorAll('select').forEach(function (s) {
        var opt = s.options[s.selectedIndex];
        if (opt) textos.push(opt.value || opt.textContent || '');
      });

      var max = 0;
      textos.forEach(function (t) {
        var m = String(t).match(/(\d+)\s*[x×]\s*(\d+)/i);
        if (m) {
          var lado = Math.max(parseInt(m[1], 10), parseInt(m[2], 10));
          if (lado > max) max = lado;
        }
      });
      return max;
    }

    function esGrande() {
      var lado = ladoMayor();
      // Sin talla detectada nos quedamos en la tarifa baja (nunca cobrar de mas).
      return lado > 100;
    }

    function variantActual() {
      return esGrande() ? root.dataset.idLargo : root.dataset.idCorto;
    }

    function pintarPrecio() {
      var grande = esGrande();
      if (priceEl) {
        priceEl.textContent = '+' + (grande ? root.dataset.precioLargo : root.dataset.precioCorto);
      }
      if (rateEl) {
        var lado = ladoMayor();
        if (lado > 0) {
          rateEl.textContent = grande ? rateEl.dataset.long : rateEl.dataset.short;
        }
      }
    }

    // El cambio de talla ocurre fuera del form: escuchamos en la seccion.
    if (section.addEventListener) section.addEventListener('change', pintarPrecio);
    form.addEventListener('change', pintarPrecio);
    document.addEventListener('variant:change', pintarPrecio);
    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
      window.subscribe(window.PUB_SUB_EVENTS.variantChange, pintarPrecio);
    }
    pintarPrecio();

    // Estado visual para navegadores sin :has()
    if (check) {
      check.addEventListener('change', function () {
        root.classList.toggle('is-on', check.checked);
      });
    }

    // --- Anadir el gel antes que el producto principal ----------------------
    if (!submitBtn) return;

    submitBtn.addEventListener(
      'click',
      function (e) {
        if (!check || !check.checked) return;
        if (root.dataset.gelPending === '1') {
          // Segunda pasada: dejamos que Dawn siga su curso.
          root.dataset.gelPending = '';
          return;
        }

        e.preventDefault();
        e.stopImmediatePropagation();
        root.dataset.gelPending = '1';

        var id = parseInt(variantActual(), 10);
        // Ojo: routes.cart_add_url es "/cart/add" (sin .js) y ahi un POST JSON
        // no devuelve la API de carrito. Hay que apuntar siempre al endpoint .js.
        var base = (window.routes && window.routes.root_url) || '/';
        if (base.slice(-1) !== '/') base += '/';
        var url = base + 'cart/add.js';

        fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('cart/add ' + r.status);
          })
          .catch(function (err) {
            // Si el extra falla no bloqueamos la venta del cuadro, pero avisamos.
            if (window.console) console.warn('[gel] no se pudo anadir el acabado:', err);
          })
          .then(function () {
            submitBtn.click();
          });
      },
      true
    );
  }

  function boot() {
    document.querySelectorAll('[data-gel-finish]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
